import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { StatusNoDataComponent } from './status-no-data.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgSelectModule,
    FormsModule
  ],
  declarations: [StatusNoDataComponent],
  exports: [StatusNoDataComponent]
})
export class StatusNoDataModule {
}
